/* Componente di selezione della lingua */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import i18n from 'i18next';

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    select: {
      '&:before': {
          borderColor: "red",
      },
      '&:after': {
          borderColor: "red",
      },
      color:'red'
    },
    icon: {
      fill: "red",
    },
}));



export default function SelectLanguage(props) {
  const classes = useStyles();
  const language = ['ENG','ITA','FRA']
  const [lan, setLan] = React.useState(props.lingua);

  /*  function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
}  */

function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/;SameSite=None";
}

//funzione di selezione della lingua e settaggio del cookie
function setLingua(value){

  switch (language[value]) {
    case 'ITA':
      i18n.changeLanguage('it');
      setCookie('googtrans', undefined, 1);
      break;
    case 'FRA':
      i18n.changeLanguage('fr');
      setCookie('googtrans', '/it/fr', 1);
      break;
      case "ENG":
        i18n.changeLanguage('en');
        setCookie('googtrans', '/it/en', 1);
        break;
    default:
      i18n.changeLanguage('it');
      setCookie('googtrans', undefined, 1);
      break;
  }
}

  const handleChange = (event) => {
    setLingua(event.target.value)
    setLan(event.target.value);
  };

  return (
    <div>
        <FormControl className={classes.formControl}>
        <Select className={classes.select} 
            inputProps={{classes: {icon: classes.icon,},}}
            value={lan}
            onChange={handleChange}
            renderValue={(value)=> language[value]}>
                <MenuItem value={1}>Italiano</MenuItem>
                <MenuItem value={0}>English</MenuItem>
                <MenuItem value={2}>Français</MenuItem>
        </Select>
        </FormControl>
    </div>
  )
}